import {apiTypeCreater} from '../utils'
export const LOGIN = apiTypeCreater("LOGIN")